import React from 'react';
//eslint-disable-next-line
import { BrowserRouter as Router, Route, Routes, BrowserRouter, useLocation } from 'react-router-dom';

import Showtimes from './components/Showtimes'; // Import your Showtimes component
import Home from './components/screens/Home';
import Cashflow from './components/Cashflow'
import TheaterRoom from './components/TheaterRoom';
import Success from './components/Success';
import Login from './components/Login';
import MovieCrawlerDashboard from './components/MovieCrawlerDashboard';
import AdminLayout from './components/admin/AdminLayout';
import AdminOverview from './components/admin/AdminOverview';
import DriverApplicationsPanel from './components/admin/DriverApplicationsPanel';
import RestaurantApplicationsPanel from './components/admin/RestaurantApplicationsPanel';
import RewardFulfillmentPanel from './components/admin/RewardFulfillmentPanel';
import ScreeningRoomPanel from './components/admin/ScreeningRoomPanel';
import AccountHub from './components/screens/AccountHub';
import ComingSoon from './components/screens/ComingSoon';
import StarViewX from './components/screens/StarViewX';
import WatchParties from './components/screens/WatchParties';
import GetTheApp from './components/screens/GetTheApp';
import GiftCards from './components/screens/GiftCards';
import Offers from './components/screens/Offers';
import CountryExclusive from './components/screens/CountryExclusive';
import Merchandise from './components/screens/Merchandise';
import RestaurantPortal from './components/screens/RestaurantPortal';
import DriverApply from './components/screens/DriverApply';
import RestaurantApply from './components/screens/RestaurantApply';
import OurBrands from './components/screens/info/OurBrands';
import ContactUs from './components/screens/info/ContactUs';
import FAQs from './components/screens/info/FAQs';
import CorporateInformation from './components/screens/info/CorporateInformation';
import InvestorConnect from './components/screens/info/InvestorConnect';
import InvestorRelations from './components/screens/info/InvestorRelations';
import MediaCenter from './components/screens/info/MediaCenter';
import Careers from './components/screens/info/Careers';
import AssociatePortal from './components/screens/info/AssociatePortal';
import Theatres from './components/screens/info/Theatres';
import RatingsInformation from './components/screens/info/RatingsInformation';
import FormatPage from './components/screens/info/FormatPage';
import VulnerabilityReporting from './components/screens/info/VulnerabilityReporting';
import CaliforniaNotice from './components/screens/info/CaliforniaNotice';
import PrivacyPolicy from './components/screens/info/PrivacyPolicy';
import TermsAndConditions from './components/screens/info/TermsAndConditions';
import StarViewTerms from './components/screens/info/StarViewTerms';
import { AuthProvider } from './auth/AuthContext';
import { CountryProvider } from './context/CountryContext';
import RouteMeta from './seo/RouteMeta';


const App = () => {


  return (
    <div>
      <CountryProvider>
        <AuthProvider>
          <BrowserRouter>
          {/* Rewrites title/description/canonical per route - the head is
              otherwise baked once at build time and identical on every page. */}
          <RouteMeta/>
          <Routes>
            <Route index element={<Home/>}/>
            <Route path="/home" element={<Home/>}/>
            <Route path="/Showtimes" element={<Showtimes/>}/>
            <Route path="/Cashflow" element={<Cashflow/>}/>
            <Route path="/TheaterRoom" element={<TheaterRoom/>}/>
            <Route path="/Success" element={<Success/>}/>
            <Route path="/Login" element={<Login/>}/>
            <Route path="/account" element={<AccountHub/>}/>
            <Route path="/coming-soon" element={<ComingSoon/>}/>
            <Route path="/starview-x" element={<StarViewX/>}/>
            <Route path="/watch-parties" element={<WatchParties/>}/>
            <Route path="/get-the-app" element={<GetTheApp/>}/>
            <Route path="/GiftCards" element={<GiftCards/>}/>
            <Route path="/Offers" element={<Offers/>}/>
            <Route path="/CountryExclusive" element={<CountryExclusive/>}/>
            <Route path="/Merchandise" element={<Merchandise/>}/>
            {/* Admin Movie Crawler route */}
            <Route path="/admin/movie-crawler" element={<MovieCrawlerDashboard/>}/>
            <Route path="/admin" element={<AdminLayout>{(secret) => <AdminOverview secret={secret} />}</AdminLayout>}/>
            <Route path="/admin/driver-applications" element={<AdminLayout>{(secret) => <DriverApplicationsPanel secret={secret} />}</AdminLayout>}/>
            <Route path="/admin/restaurant-applications" element={<AdminLayout>{(secret) => <RestaurantApplicationsPanel secret={secret} />}</AdminLayout>}/>
            <Route path="/admin/reward-fulfillment" element={<AdminLayout>{(secret) => <RewardFulfillmentPanel secret={secret} />}</AdminLayout>}/>
            <Route path="/admin/screening-room" element={<AdminLayout>{(secret) => <ScreeningRoomPanel secret={secret} />}</AdminLayout>}/>
            <Route path="/partner/restaurant" element={<RestaurantPortal/>}/>
            <Route path="/drive" element={<DriverApply/>}/>
            <Route path="/partner/restaurant/apply" element={<RestaurantApply/>}/>
            <Route path="/our-brands" element={<OurBrands/>}/>
            <Route path="/contact-us" element={<ContactUs/>}/>
            <Route path="/faqs" element={<FAQs/>}/>
            <Route path="/corporate-information" element={<CorporateInformation/>}/>
            <Route path="/investor-connect" element={<InvestorConnect/>}/>
            <Route path="/investor-relations" element={<InvestorRelations/>}/>
            <Route path="/media-center" element={<MediaCenter/>}/>
            <Route path="/careers" element={<Careers/>}/>
            <Route path="/associate-portal" element={<AssociatePortal/>}/>
            <Route path="/theatres" element={<Theatres/>}/>
            <Route path="/ratings-information" element={<RatingsInformation/>}/>
            <Route path="/formats/:formatId" element={<FormatPage/>}/>
            <Route path="/vulnerability-reporting" element={<VulnerabilityReporting/>}/>
            <Route path="/california-collection-notice" element={<CaliforniaNotice/>}/>
            <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
            <Route path="/terms-and-conditions" element={<TermsAndConditions/>}/>
            <Route path="/starview-cinema-terms-and-conditions" element={<StarViewTerms/>}/>
          </Routes>
          </BrowserRouter>
        </AuthProvider>
      </CountryProvider>
    </div>
  );
}

export default App;
